import regionsData from '@openx/components-direct-deals/lib/data/regionCountryData.json';

export const getCountryNames = (codes: string[]): string[] => {
  const countryNames: string[] = [];

  for (const region of Object.values(regionsData.regions)) {
    for (const country of region.countries) {
      if (codes.includes(country.id)) {
        countryNames.push(country.name);
      }
    }
  }

  return countryNames;
};
